<template>
    <div class="mt-4">
        <div class="form-group mb-0 d-flex" style="align-items: center">
            <input
                v-model="moznosti.accept_refuse"
                type="checkbox"
                class="toggle testing_acceptdeclineoffer"
            />
            <label
                class="block mb-0"
                @click="moznosti.accept_refuse = !moznosti.accept_refuse"
                style="cursor: pointer"
            >
                {{ $t('offer.checkbox_accept_title') }}
            </label>
            <div class="info">
                <div class="my_tooltip">
                    {{ $t('offer.checkbox_accept_hint') }}
                </div>
                <div class="tooltip_hover info_icon">
                    <img src="/img/create_offer/info.svg" alt="" />
                </div>
            </div>
        </div>
        <div class="form-group mb-0 mt-2 mobile_doba_inputs">
            <div class="d-flex">
                <input
                    v-model="showDelivery"
                    type="checkbox"
                    class="toggle testing_deliverytime"
                />
                <label
                    class="block mb-0 mt-1"
                    @click="showDelivery = !showDelivery"
                    style="cursor: pointer"
                >
                    {{ $t('offer.checkbox_delivery_cta') }}
                </label>
                <div class="info">
                    <div class="my_tooltip">
                        {{ $t('offer.checkbox_delivery_hint') }}
                        popis.
                    </div>
                    <div class="tooltip_hover info_icon">
                        <img src="/img/create_offer/info.svg" alt="" />
                    </div>
                </div>
            </div>
            <div v-show="showDelivery" class="doba_inputs mt-3 mb-3">
                <div class="form-floating mb-3">
                    <input
                        v-model="moznosti.delivery.time"
                        type="text"
                        class="form-control testing_deliverytime_input"
                        id="floatingInput"
                        placeholder="Doba dodania"
                    />
                    <label for="floatingInput">Doba dodania</label>
                </div>
                <div class="form-floating">
                    <textarea
                        v-model="moznosti.delivery.text"
                        class="form-control testing_deliverytime_textarea"
                        placeholder="Text"
                        id="floatingTextarea2"
                        style="height: 100px"
                    ></textarea>
                    <label for="floatingTextarea2">Text</label>
                </div>
            </div>
        </div>
        <div
            v-if="!premium.id"
            class="form-group d-flex mb-0 mt-2"
            style="align-items: center; opacity: 0.5; cursor: no-drop"
        >
            <input
                style="cursor: no-drop"
                type="checkbox"
                class="toggle testing_clientsreviews"
                disabled
            />
            <label class="block mb-0 mt-1">
                {{ $t('offer.checkbox_reviews_title') }}
            </label>
        </div>
        <div class="form-group d-flex mb-0 mt-2" style="align-items: center">
            <input
                v-show="premium.id"
                v-model="moznosti.reviews"
                type="checkbox"
                class="toggle"
            />
            <label
                v-show="premium.id"
                class="block mb-0 mt-1"
                @click="moznosti.reviews = !moznosti.reviews"
                style="cursor: pointer"
            >
                {{ $t('offer.checkbox_reviews_title') }}
            </label>
            <div v-show="premium.id" class="info">
                <div class="my_tooltip">
                    {{ $t('offer.checkbox_reviews_hint') }}
                    Môže ti to pomôcť vyhrať zákazku.
                </div>
                <div class="tooltip_hover info_icon">
                    <img src="/img/create_offer/info.svg" alt="" />
                </div>
            </div>
        </div>
        <div v-show="!premium.id" class="premium-info">
            <img src="/img/create_offer/crown.svg" alt="" />
            <p>
                Chceš uverejniť
                <b>recenzie</b>
                svojich klientov v ponuke?
                <b>
                    <a href="/admin/balicky">Prejdi na PREMIUM.</a>
                </b>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ["premium", "options"],
    data() {
        return {
            showDelivery: false,
            moznosti: {
                accept_refuse: false,
                reviews: false,
                delivery: {
                    time: null,
                    text: null,
                },
            },
        };
    },
    mounted() {
        $(".tooltip_hover").hover(
            function () {
                $(this).parent().find(".my_tooltip").css("opacity", "1");
            },
            function () {
                $(this).parent().find(".my_tooltip").css("opacity", "0");
            }
        );
    },
    watch: {
        showDelivery: function () {
            if (!this.showDelivery) {
                this.moznosti.delivery = {
                    time: null,
                    text: null,
                };
            }
        },
        options: {
            handler() {
                this.moznosti.accept_refuse =
                    this.options.confirmed_status == 1 ? true : false;
                this.moznosti.reviews = false;
                if (this.options.reviews == 1) this.moznosti.reviews = true;
                if (this.options.dodanie != null) {
                    this.showDelivery = true;
                    this.moznosti.delivery.time = this.options.dodanie;
                    this.moznosti.delivery.text = this.options.dodanie_text;
                }
            },
            deep: true,
        },
        moznosti: {
            handler() {
                this.$emit("sendMoznosti", this.moznosti);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.premium-info {
    width: 100%;
    height: auto;
    padding: 13px;
    background: #fff7ed;
    border: 1px solid #fbbf24;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    align-items: center;
    margin: 18px 0;
    @media (max-width: 620px) {
        display: grid;
        padding: 15px 10px;
        height: auto;
        width: 100%;
    }
    img {
        margin-right: 10px;
        @media (max-width: 620px) {
            margin: 0 auto 10px auto;
        }
    }
    p {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #9a3412;
        margin-bottom: 0;
        b {
            a {
                text-decoration: underline;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                text-align: center;
                color: #9a3412;
            }
        }
    }
}
label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}
label {
    @media (max-width: 600px) {
        width: 70%;
    }
}
input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #c7d4eb;
    border-radius: 25px;
}
.toggle label {
    @media (max-width: 600px) {
        width: 70%;
    }
}
.toggle {
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #ffffff;
    border-radius: 3px;
    transition: all 0.2s ease;
    &:focus {
        outline: 0;
    }
    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    &:checked {
        border-color: #2ed8b6;
        background: #2ed8b6;
    }
    &:checked:after {
        transform: translatex(20px);
    }
}
.mobile_doba_inputs {
    display: grid !important;
}
.doba_inputs {
    background: white;
    padding: 20px;
    width: 100%;
    @media (max-width: 550px) {
        margin: 20px 0 !important;
    }
    .form-floating > label,
    .float-container label {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
    }
    input {
        height: 50px;
        border-radius: 0;
    }
    textarea {
        border-radius: 0;
    }
}
.info {
    position: relative;
    height: 20px;
    margin-left: 10px;
    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img {
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }
}
.agree_tooltip {
    position: relative;
}
.my_tooltip {
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;
    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>
